import config from "config/config";
import { Notification } from "models/Notification";
import { SysMessage } from "models/user/user";
import { apiRequest, baseApiRequest } from "./apiInterceptor";

export class NotificationsAPI {
  static async fetchNotifications(): Promise<Notification[]> {
    const response = await apiRequest.get(config.api.user.notifications);
    const result: Notification[] = response.body;
    return result;
  }

  static async addToCustomerResponseAccepted(id: string) {
    return apiRequest.put(config.api.user.notificationAccepted(id));
  }

  static async addToCustomerResponseRejected(id: string) {
    return apiRequest.put(config.api.user.notificationRejected(id));
  }

  static async deleteNotification(id: string) {
    return apiRequest.delete(config.api.notifications.deleteSystemMessage(id));
  }

  static async sendSystemMessage(
    message: string,
    hours: string
  ): Promise<Notification> {
    const response = await apiRequest
      .post(config.api.notifications.systemMessage)
      .send({
        message: message,
        validInHours: hours
      });
    const result: Notification = response.body;
    return result;
  }

  static async sendSystemMessageExternal(sysMessage: {
    message: string;
    hours: string;
  }): Promise<SysMessage> {
    const response = await apiRequest
      .post(config.api.sysMessageExternal.put)
      .send({
        message: sysMessage.message,
        validInHours: sysMessage.hours
      });
    const sysMessageResult: SysMessage = response.body;
    return sysMessageResult;
  }

  static async fetchSysMessage() {
    const response = await baseApiRequest
      .get(config.api.sysMessageExternal.get)
      .set("Accept", "application/json")
      .send();

    return response.body;
  }
}
